import { useState } from "react";
import {CancelButton,SubmitButton,} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import {FormikSelectTwoSmall,} from "../../../../../../Components/Utils/Select";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import {DownloadPDF,DownloadXLXS,} from "../../../../../../Components/Utils/Download";
import useFetchMDIndex from "../../../../../../Components/Hooks/useFetchMDIndex";

function ClientReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "statusClient"
  );
  const headers = [
    {
      title: "Company",
      width: "15%",
      field: "Company",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Contact Person",
      width: "15%",
      field: "ContactPerson",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Designation",
      width: "15%",
      field: "Designation",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Phone",
      width: "15%",
      field: "Phone",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Email",
      width: "15%",
      field: "Email",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Location",
      width: "15%",
      field: "Location",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status",
      width: "15%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    status: "",
    designation:""
  });

  const [params, setParams] = useState({
    status: "",
    designation:""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
        status: value.status,
        designation:value.designation
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-clients",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
      designation:""
    });
  }

  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination"
  );

  return (
    <>
      <div className="w-full h-full overflow-auto">
        <div className="w-full   items-center gap-x-3">
          <div className="flex gap-x-2 justify-between  w-full  py-2">
            <div className=" max-w-[250px] pr-7 ">
              <p className=" font-semibold text-xs 2xl:text-sm  ">
                Clients Report : {data?.length}
              </p>
            </div>
            <div className=" flex-1 ">
              <form onSubmit={formik.handleSubmit}>
                <div className=" w-full grid grid-cols-3 gap-3">
                  <FormikSelectTwoSmall
                    type="text"
                    label="Designation"
                    placeholder="Designation"
                    Options={designation}
                    formik={formik}
                    name="designation"
                    width="w-full "
                  />
                  <FormikSelectTwoSmall
                    label="Status"
                    Options={status}
                    formik={formik}
                    placeholder="Choose"
                    name="status"
                    width="w-full "
                  />

                  <div className=" w-full flex justify-end ">
                    <div className=" w-full flex items-end gap-2">
                      <SubmitButton name="Apply" />
                      <CancelButton
                        label="Clear"
                        handleClick={closeFilterDialog}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className=" w-[80px] flex justify-end items-end gap-4 ">
              <DownloadPDF
                url={`/xlsx-report/export-clients-report-pdf`}
                fileName="Clients Report"
                params={params}
              />
              <DownloadXLXS
               url={`/xlsx-report/export-clients-report-excel`}
                fileName="Clients Report"
                params={params}
               />
            </div>
          </div>
        </div>

        <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default ClientReport;
